// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"5c0edb46","453":"428f96bd","540":"a6ea8cb5","732":"991d4190"}[chunkId] + ".chunk.js";
};